import React, { Component } from 'react'
import styled from 'styled-components'
import axios from 'axios'
import ReactTable from 'react-table'
import { API_URL, DOWNLOAD_URL } from '../constants'
import { PageWrapper, Checkbox, TextArea, TextField, FormikForm, FlexWrapper, Modal, Button } from '../components'
import { Formik, Field } from 'formik'
import 'react-table/react-table.css'
import moment from 'moment'
import { isEmpty, get } from 'lodash'
import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
  body>div{
    max-width:100% !important;
  }
`

const TableWrap = styled.div`
  position: relative;
  .ReactTable.-striped.-highlight {
    padding-bottom: 50px;
  }
  .rt-thead.-header {
    background: #078489;
    color: #fff;
  }
  .rt-td {
    white-space: normal !important;
  }
  .pagination-bottom {
    position: fixed;
    bottom: 0;
    width: 100%;
    background: #078489;
    color: #fff;
  }
  .ReactTable .-pagination .-btn[disabled] {
    color: #fff;
    opacity: 0.9;
  }
  .ReactTable .-pagination .-btn {
    color: #fff;
  }
  .rt-tbody {
    /* max-height: calc(100vh - 93px); */
  }
`
class UserFeedback extends Component {
  state = { loader: false, feedbackData: [] }
  componentDidMount() {
    this.getUserFeedback()
  }

  getUserFeedback = async () => {
    const query = {
      filter: {
        order: ['id desc']
      }
    }
    try {
      const { data } = await axios.get(`${API_URL}/UserFeedbacks`, { params: { filter: query.filter } })
      this.setState({ feedbackData: data })
    } catch (error) {
      console.log(error)
    }
  }

  render() {
    const { feedbackData } = this.state
    return (
      <React.Fragment>
        <GlobalStyle />
        <PageWrapper viewPadding="0 20px" height="auto" modifyPadding="0 20px">
          <TableWrap>
            <ReactTable
              data={feedbackData}
              columns={[
                {
                  Header: 'Timestamp',
                  accessor: 'createdAt',
                  Cell: row =>
                    row.original.createdAt
                      ? moment(get(row.original, 'createdAt', '')).format('DD MMM YYYY HH:mm:ss')
                      : '',
                  width: 150
                },
                {
                  Header: 'ID',
                  accessor: 'id',
                  width: 50
                },
                {
                  Header: 'UserId',
                  accessor: 'userId',
                  width: 70
                },
                {
                  Header: 'UserEmail',
                  accessor: 'email',
                  Cell: row => (
                    <a href={`mailto: ${get(row.original, 'email', '')}`}>{get(row.original, 'email', '')}</a>
                  ),
                  width: 300
                },
                {
                  Header: 'Type',
                  accessor: 'type',
                  width: 170
                },
                {
                  Header: 'Column 1(Brand)',
                  accessor: 'extra_one',
                  width: 300
                },
                {
                  Header: 'Column 2(Product Name)',
                  accessor: 'extra_two',
                  width: 300
                },
                {
                  Header: 'Image',
                  Cell: row =>
                    isEmpty(get(row.original, 'image', '')) ? (
                      <img src={require('../static/images/no-image.png')} height="100px" alt={'demo'} />
                    ) : (
                      <a href={`${DOWNLOAD_URL}/${get(row.original, 'image', '')}`} target="_blank">
                        <img
                          src={`${DOWNLOAD_URL}/${get(row.original, 'image', '')}`}
                          height="150px"
                          width="150px"
                          objectFit="cover"
                          alt={get(row.original, 'type', '')}
                        />
                      </a>
                    ),
                  width: 150
                }
              ]}
              defaultPageSize={50}
              // pageSize={5}
              minRows={0}
              resizable={false}
              className="-striped -highlight"
            />
          </TableWrap>
        </PageWrapper>
      </React.Fragment>
    )
  }
}
export default UserFeedback



// WEBPACK FOOTER //
// ./src/pages/UserFeedback.js